import React from 'react';
import { connect } from 'react-redux';
import { RootState } from 'reducers';
import { RouteComponentProps } from 'react-router-dom';
import { Constants, checkPermission } from 'utils';
import { Table, Pagination, Tooltip, Modal } from 'components';
import { AddIcon, ViewIcon } from 'assets/icons';
import moment from 'moment';
import { NotificationService } from 'services';
import ModalCreate from './modal-create';
import ViewDetail from './view-detail';

interface Props extends RootState, RouteComponentProps {
  dispatch: any;
}

class AdminNotifications extends React.Component<Props> {
  state = {
    header: ['Fecha', 'Título', 'Dirigido a', 'Leídas', 'Acciones'],
    data: [],
    page: 1,
    last_page: 1,
    visible: false,
    visible_detail: false,
    item: null,
  };

  componentDidMount() {
    this.props.dispatch({
      type: 'SET_HEADER',
      payload: {
        title: 'Comunicados',
        onBack: null,
      },
    });

    this.props.dispatch({
      type: 'SET_SUBHEADER',
      payload: {
        title: '',
      },
    });

    this.load();
  }

  // admin/notifications/get solo acepta page/per_page (ver GetParams en el
  // backend) -- no soporta filtrar por título ni por segment_type todavía.
  load = async (withoutLoading: boolean = false) => {
    const res: any = await NotificationService.admin.get({
      withoutLoading,
      page: this.state.page,
    });
    this.setState({
      data: res.notifications.rows,
      last_page: res.notifications.count,
    });
  };

  add = () => {
    this.setState({
      visible: true,
    });
  };

  onClose = () => {
    this.setState(
      {
        visible: false,
        item: null,
      },
      () => this.load(true),
    );
  };

  view = (e: any, item: any) => {
    e.preventDefault();
    this.setState({
      visible_detail: true,
      item,
    });
  };

  onCloseDetail = () => {
    this.setState({
      visible_detail: false,
      item: null,
    });
  };

  segmentLabel = (item: any) => {
    switch (item.segment_type) {
      case Constants.NOTIFICATION_SEGMENT_TYPE.ALL_CLIENTS:
        return 'Todos los clientes';
      case Constants.NOTIFICATION_SEGMENT_TYPE.ALL_LAWYERS:
        return 'Todos los abogados';
      default:
        return `Personalizado (${item.recipients_count ?? 0})`;
    }
  };

  render() {
    const { visible, visible_detail } = this.state;

    return (
      <div id='admin-notifications'>
        <Modal
          className='modal-create-notification'
          visible={visible}
          title='Nuevo Comunicado'
          onClose={() => this.onClose()}
        >
          <ModalCreate onClose={() => this.onClose()} />
        </Modal>

        <Modal
          className='modal-view-notification'
          visible={visible_detail}
          title={(this.state.item as any)?.title || 'Comunicado'}
          onClose={() => this.onCloseDetail()}
        >
          {visible_detail && <ViewDetail item={this.state.item} />}
        </Modal>

        <Table
          title='Notificaciones'
          data={this.state.data.length}
          header={this.state.header}
          rightAlign={[4]}
          titleRight={
            <>
              {checkPermission(Constants.MODULES.NOTIFICATIONS, 'write') && (
                <div className='container-add-table' onClick={() => this.add()}>
                  <p>Nueva</p>
                  <button className='btn add-btn-table'>
                    <img src={AddIcon} />
                  </button>
                </div>
              )}
            </>
          }
        >
          {this.state.data.map((i: any, index: number) => {
            return (
              <tr key={index}>
                <td>
                  {moment(i.created_at).isValid()
                    ? moment(i.created_at).format('DD/MM/YYYY HH:mm')
                    : ''}
                </td>
                <td>{i.title}</td>
                <td>{this.segmentLabel(i)}</td>
                <td>
                  {i.read_count ?? 0}/{i.recipients_count ?? 0}
                </td>
                <td className='text-right'>
                  <Tooltip title='Ver'>
                    <a className='link-icon' href='#' onClick={(e: any) => this.view(e, i)}>
                      <img src={ViewIcon} />
                    </a>
                  </Tooltip>
                </td>
              </tr>
            );
          })}
        </Table>

        <Pagination
          pages={this.state.last_page}
          active={this.state.page}
          onChange={async (page: number) => {
            await this.setState({
              page: page,
            });
            this.load();
          }}
        />
      </div>
    );
  }
}

export default connect((state: RootState) => {
  return {
    user: state.user,
  };
})(AdminNotifications);
